import { Fragment, useRef } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import Like from '../../../assets/images/SurveyThumbUp.svg';

const ChallangeSuccessModal = ({ open, message, btn, desc, handleClose }) => {
  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" initialFocus={cancelButtonRef} onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full  justify-center p-4 text-center items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-3xl bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder dark:text-white text-left shadow-xl transition-all sm:my-8">
                <div className="h-fit md:w-[692px] sm:w-[500px] w-[calc(100% - 2rem)] rounded-[24px] md:px-40 md:py-16 p-8 bg-shoorah-normanGray dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray">
                  <div className="flex justify-center">
                    <img src={Like} alt="Like" />
                  </div>
                  <h1 className="text-2xl font-medium text-center mt-6 text-shoorah-lightBlack dark:text-shoorah-darkBg">
                    {message}
                  </h1>
                  <p className="text-base font-normal text-shoorah-lightBlack dark:text-shoorah-darkBg text-center mt-4">
                    {desc}
                  </p>

                  <button
                    onClick={handleClose}
                    className="bg-[#1F1F1F] rounded-full px-10 py-3 text-white text-lg block mx-auto mt-8"
                  >
                    {btn}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default ChallangeSuccessModal;
